import { z } from "zod";
import { ContentObjectiveGoals } from "@/types/brand";
import { BrandsToneOptions } from "@/types/pocketbase-types";

export const BrandFormSchema = z.object({
  name: z.string().min(2, {
    message: "Brand name must be at least 2 characters.",
  }),
  url: z.string().url({
    message: "Please enter a valid website URL.",
  }),
  logo: z.string().optional(),
  primaryColor: z.string(),
  secondaryColor: z.string(),
  description: z.string().min(10, {
    message: "Please provide a brief description of your brand.",
  }),
  targetAudience: z.string().min(5, {
    message: "Please describe your target audience.",
  }),
  tone: z.nativeEnum(BrandsToneOptions),
  contentObjectives: z.object({
    goals: z.array(z.nativeEnum(ContentObjectiveGoals)).min(1, {
      message: "Please select at least one content objective.",
    }),
  }),
  uniqueValue: z.string().min(10, {
    message: "Please provide your unique value proposition.",
  }),
  additionalNotes: z.string().optional(),
  language: z.string().min(1, {
    message: "Please select a language for your brand content.",
  }),
  location: z.string().min(1, {
    message: "Please select a country for your brand.",
  }).optional(),
});
